import React, { useContext, useEffect, useState } from 'react'
import './register.css'
import { useNavigate } from 'react-router-dom'
import { createUserWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../config/firebase'

export default function Register(props) {
    const navigate = useNavigate()
    
    const [ email, setEmail ] = useState('')
    const [ password, setPassword ] = useState('')

    const onSubmit = async (e)=>{
        await createUserWithEmailAndPassword(auth, email, password)
            .then((userCredentials)=>{
                const user = userCredentials.user
                console.log(user)
                // navigate("/login")
            })
            .catch((error)=>{
                console.error(error)
            })
    }

  return (
    <div className="register-container">
        <div className="account">
            <div className={`register move-front`}>
                <div className="register-content">
                    <form action="#">
                        <h1>Create Account</h1>
                        <input type="text" placeholder="Name" />
                        <input type="email" placeholder="Email" value={email} onChange={(e)=>{setEmail(e.currentTarget.value)}}/>
                        <input type="password" placeholder="Password" value={password} onChange={(e)=>{setPassword(e.currentTarget.value)}}/>
                        <button onClick={()=>{onSubmit()}} > Sign Up</button>
                    </form>
                    <span>Sign up using</span>
                    <div className="social-container">
                        <a href="#" className="social"><i className="fab fa-facebook-f"></i></a>
                        <a href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
                        <a href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
                    </div>
                </div>
            </div>
            <div className={`login move-back`}>
                <div className="login-content">
                    <form action="#">
                        <h1>Sign in</h1>
                        <input type="email" placeholder="Email" />
                        <input type="password" placeholder="Password" />
                        <a href="#">Forgot your password?</a>
                        <button>Sign In</button>
                    </form>
                        <span>Use your account from</span>
                        <div className="social-container">
                            <a href="#" className="social"><i className="fab fa-facebook-f"></i></a>
                            <a href="#" className="social"><i className="fab fa-google-plus-g"></i></a>
                            <a href="#" className="social"><i className="fab fa-linkedin-in"></i></a>
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}
